import React, { useEffect, useState } from "react";
import { api, rupee } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const empty = { name: "", role: "Sales assistant", phone: "", monthly_salary: "", joining_date: new Date().toISOString().slice(0, 10), address: "" };

export default function Staff() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const [showAdd, setShowAdd] = useState(false);

  const load = () => api.get("/staff").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/staff", { ...form, monthly_salary: Number(form.monthly_salary) });
      toast.success("Staff added");
      setForm(empty); setShowAdd(false); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
  };

  const del = async (id) => { if (!window.confirm("Remove?")) return; await api.delete(`/staff/${id}`); load(); };

  return (
    <div className="p-6 md:p-10 max-w-6xl mx-auto" data-testid="staff-root">
      <div className="flex justify-between items-start mb-6">
        <h1 className="font-display font-bold text-3xl">Staff</h1>
        <button data-testid="staff-add-btn" onClick={() => setShowAdd(true)} className="inline-flex items-center gap-2 px-5 h-12 rounded-md text-white tactile-btn font-semibold" style={{ background: "var(--primary)" }}>
          <Plus size={18} /> Add staff
        </button>
      </div>
      <div className="card-soft">
        <table className="w-full text-sm zebra">
          <thead><tr className="text-left" style={{ color: "var(--text-muted)" }}><th className="p-3">Name</th><th>Role</th><th>Phone</th><th>Joined</th><th className="text-right">Salary</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-10" style={{ color: "var(--text-muted)" }}>No staff yet.</td></tr>}
            {items.map((s) => (
              <tr key={s.id} className="border-t" style={{ borderColor: "var(--border-soft)" }} data-testid={`staff-row-${s.phone}`}>
                <td className="p-3 font-medium">{s.name}</td><td>{s.role}</td><td>{s.phone}</td><td>{s.joining_date}</td><td className="text-right num">{rupee(s.monthly_salary)}</td>
                <td className="text-right pr-3"><button data-testid={`staff-del-${s.phone}`} onClick={() => del(s.id)} style={{ color: "var(--error)" }}><Trash2 size={16} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showAdd && (
        <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={() => setShowAdd(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={save} className="bg-white rounded-xl p-6 w-full max-w-lg">
            <h2 className="font-display font-bold text-xl mb-4">Add staff</h2>
            <div className="grid grid-cols-2 gap-3">
              <F label="Name*" required v={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="add-staff-name" />
              <F label="Role" v={form.role} onChange={(v) => setForm({ ...form, role: v })} testid="add-staff-role" />
              <F label="Phone*" required v={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="add-staff-phone" />
              <F label="Monthly salary*" type="number" required v={form.monthly_salary} onChange={(v) => setForm({ ...form, monthly_salary: v })} testid="add-staff-salary" />
              <F label="Joining date" type="date" v={form.joining_date} onChange={(v) => setForm({ ...form, joining_date: v })} testid="add-staff-joining" />
              <div className="col-span-2"><F label="Address" v={form.address} onChange={(v) => setForm({ ...form, address: v })} testid="add-staff-address" /></div>
            </div>
            <div className="flex gap-3 mt-5">
              <button type="button" onClick={() => setShowAdd(false)} className="h-11 px-5 rounded-md border" style={{ borderColor: "var(--border-soft)" }}>Cancel</button>
              <button data-testid="add-staff-save" className="h-11 px-6 rounded-md text-white tactile-btn font-semibold" style={{ background: "var(--primary)" }}>Save</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

function F({ label, v, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <input data-testid={testid} required={required} type={type} value={v} onChange={(e) => onChange(e.target.value)} className="mt-1 w-full h-11 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} />
    </div>
  );
}
